import Axios from "axios";
var SystemSettingsService = (function () {
    function SystemSettingsService() {
    }
    SystemSettingsService.prototype.getSystemSettings = function (params) {
        return Axios.get("supplierclientapi/stockinit/list", { params: params });
    };
    SystemSettingsService.prototype.save = function (params) {
        return Axios.post("supplierclientapi/stockinit/list", { params: params });
    };
    SystemSettingsService.prototype.getThirdPartyPaymentList = function (params) {
        return Axios.get("supplierclientapi/supplierpaymentconfig/list", { params: params });
    };
    SystemSettingsService.prototype.getPayTypeList = function (params) {
        return Axios.get("supplierclientapi/supplierpaymentconfig/pay_type_list", { params: params });
    };
    SystemSettingsService.prototype.getPayPass = function (params) {
        return Axios.get("supplierclientapi/supplierpaymentconfig/channel_list", { params: params });
    };
    SystemSettingsService.prototype.addPay = function (params) {
        return Axios.post("supplierclientapi/supplierpaymentconfig/create", params);
    };
    SystemSettingsService.prototype.editPay = function (params) {
        return Axios.post("supplierclientapi/supplierpaymentconfig/update", params);
    };
    SystemSettingsService.prototype.deletePay = function (params) {
        return Axios.post("supplierclientapi/supplierpaymentconfig/delete", params);
    };
    SystemSettingsService.prototype.getSupplierConfigdetail = function (params) {
        return Axios.post("supplierclientapi/supplier_config/detail", params);
    };
    SystemSettingsService.prototype.saveSupplierConfig = function (params) {
        return Axios.post("supplierclientapi/supplier_config/save_edi", params);
    };
    SystemSettingsService.prototype.getSortingSettings = function (params) {
        return Axios.post("supplierclientapi/supplier_config/sorting_detail", params);
    };
    SystemSettingsService.prototype.saveSortingSettings = function (params) {
        return Axios.post("supplierclientapi/supplier_config/save_sorting", params);
    };
    SystemSettingsService.createInstance = function () {
        SystemSettingsService.getInstance();
    };
    SystemSettingsService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return SystemSettingsService;
}());
export default SystemSettingsService;
